const Joi = require("joi");

const podSchema = (data) => {
  const schema = Joi.object({
    PodCode: Joi.string()
      .pattern(new RegExp("^[a-zA-Z0-9-]([^ ]?[a-zA-Z0-9 -]*)?$")) // Start with alphanumeric, no leading/trailing spaces, no consecutive spaces
      .required()
      .messages({
        "string.pattern.base": "Please enter POD Code.",
        "any.required": "Please enter POD Code.",
        "string.empty": "Please enter POD Code.",
      }),

    PodName: Joi.string()
      .pattern(new RegExp("^[a-zA-Z0-9-]([^ ]?[a-zA-Z0-9 -]*)?$")) // Start with alphanumeric, no leading/trailing spaces, no consecutive spaces
      .required()
      .messages({
        "string.pattern.base": "Please enter POD Name.",
        "any.required": "Please enter POD Name.",
        "string.empty": "Please enter POD Name.",
      }),
  }).unknown(true);

  return schema.validate(data, {
    abortEarly: false,
  });
};

module.exports = podSchema;
